import { useRef } from "react";

export default function useDebounce(fn, delay) {
  const timeoutRef = useRef(0);

  function debouncedFn(...args) {
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      fn(...args);
    }, delay);
  }

  return debouncedFn;
}